<template>
  <div style="width: 100%;">
    <div class="wraper">
      <div class="top">
        <div class="logo_part" style="white-space:nowrap;"><span ><img src="../../static/images/logo.png"></span> <em style="color: white;letter-spacing:2px;display: none">（试运行）</em> <div style="float: left;">
          <!--<div class="el-tag el-tag&#45;&#45;danger el-tag&#45;&#45;dark"-->
          <!--style="height: 60px;width: 18px;-webkit-writing-mode: vertical-rl;writing-mode: vertical-rl;text-align: center;line-height: 0px;-->
          <!--font-size: 10px;letter-spacing:1px">-->
          <!--</div>-->
        </div>
        <!--  <em style="margin-left: 18px;">
          {{areaName}}</em><i style="margin-left: 0px;">
            <a href="javascript:void(0)" @click="setQhClick()" >切换</a>
        </i>-->
          <u style="padding-left: 20px;"><b style="padding-right: 8px;">{{sj_str}}&nbsp;{{week_str}}</b>    </u></div>
        <div style="float: left;display: none"><img src="../../static/images/yszy6.png" style="width: 44px;height: auto;opacity:1"  /></div>
        <div class="login" v-if="!isLogin" >
          <div v-if="loginType=='system'"><a href="javascript:void(0)" @click="loginClick('sms')" style="padding-right: 0px;">登录/注册</a></div>
          <div v-if="loginType=='threeLogin'"><a href="javascript:void(0)" @click="threeLogin()" style="padding-right: 0px;">登录/注册</a></div>
        </div>
        <div class="login" v-if="isLogin">
          <a href="javascript:void(0)" @click="goOut"  style="padding-right: 0px;padding-left: 0px;" v-if="loginType=='system'">【退出】</a>
          <a href="javascript:void(0)" @click="threeGoOut"  style="padding-right: 0px;padding-left: 0px;" v-if="loginType=='threeLogin'">【退出】</a>
        </div>
        <div class="login" v-if="isLogin">
          <a href="javascript:void(0)"  @click="urlTo('personal_cardMaking')" :title="userName" style="padding-right: 0px;padding-left: 0px;width:180px;display: block;overflow:hidden;word-break:keep-all;white-space:nowrap;text-overflow:ellipsis;">欢迎您：{{userName}}</a>
        </div>

      </div>
    </div>
    <div class="nav">
      <div class="wraper">
        <ul>
          <li><a  href="javascript:void(0)" @click="urlTo('home')" :class="getClass('home')">首页</a></li>
          <li><a href="javascript:void(0)" :class="getClass('applyIndex')" @click="urlTo('applyIndex')">个人办事</a></li>
<!--
          <li><a href="javascript:void(0)" :class="getClass('magicApplyIndex')" @click="urlTo('magicApplyIndex')">法人办事</a></li>
-->
          <li><a href="javascript:void(0)" @click="urlTo('policyServiceIndex')" :class="getClass('policyServiceIndex')">政策知识</a></li>
          <li><a href="javascript:void(0)"  @click="urlTo('convenientIndex')" :class="getClass('convenientIndex')">便民查询</a></li>
<!--          <li><a href="javascript:void(0)" @click="urlTo('noticeIndex')" :class="getClass('noticeIndex')">通知公告</a></li>-->
          <li><a href="javascript:void(0)" @click="urlTo('pubGroupIndex')" :class="getClass('pubGroupIndex')">公示公开</a></li>
<!--          <li><a href="javascript:void(0)"  @click="urlTo('suggestIndex')" :class="getClass('suggestIndex')">阳光互动</a></li>-->
          <li><a href="https://mzt.qinghai.gov.cn/guestbook/" target="_blank" :class="getClass('suggestIndex')">阳光互动</a></li>

     <!--     <li><a href="javascript:void(0)"  @click="urlTo('appointmentIndex')" :class="getClass('convenientIndex')">预约服务</a></li>-->
        </ul>
      </div>
    </div>
    <div style="line-height: 35px;">
      <el-dialog  :visible.sync="clauseShow" :lock-scroll="false" width="600px" >
        <div style="text-align: center;font-size: 18px;margin-top: -30px;">{{this.cTitle}}</div>
        <div style="font-size: 14px;margin-left: 40px;margin-right: 35px;"><p v-html="this.cContent">{{this.cContent}}</p></div>
        <div style="margin-top: 30px;margin-left: 420px">
          <el-button type="primary" @click="clauseClose" >我已详细阅读</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="dialog_css">
      <el-dialog  :visible.sync="dialogTableVisible"  :lock-scroll="false" @close="closeHandle" width="464px" :close-on-click-modal="false">

       <div>
          <div class="login_banner"><img src="../../static/images/login_banner.png"></div>
          <div>
            <el-tabs type="border-card" v-model="loginTabs" >
           <!--   <el-tab-pane label="个人登陆" name="first">-->

                <div class="login-box">
                  <ul>
                    <li v-if="telShow">
                      <label><i class="icon4">&nbsp;</i></label>
                      <input  v-model="usertel" type="text" class="dfp_text" maxlength="11"   placeholder="请输入手机号">
                    </li>
                    <li class="yzm_con" v-if="smsShow">
                      <label><i class="icon5">&nbsp;</i></label>
                      <input type="text" class="yzm_text" v-model="smsCode" maxlength="4" placeholder="输入短信校验码">
                      <div class="yzm">
                           <span id="verifysms">  <el-link type="primary" v-bind:disabled="smsIsDisabled" v-on:click="getSmsCode"  class="code">{{smsText}}</el-link>
                           <i class="ref">&nbsp;</i></span>
                      </div>
                    </li>
                    <li v-if="pwdShow">
                      <label><i class="icon2">&nbsp;</i></label>
                      <input type="password"  class="dfp_text" v-model="password" maxlength="20" placeholder="输入密码">
                      <i class="eye-line">&nbsp;</i>
                      <i class="eye">&nbsp;</i>
                      <em></em>
                    </li>
                    <li v-if="qrpwdShow">
                      <label><i class="icon2">&nbsp;</i></label>
                      <input type="password"  class="dfp_text" v-model="qrpassword" maxlength="20" placeholder="输入确认密码">
                      <i class="eye-line">&nbsp;</i>
                      <i class="eye">&nbsp;</i>
                      <em></em>
                    </li>

                    <li v-if="verificationShow" class="yzm_con">
                      <label><i class="icon3">&nbsp;</i></label>
                      <input type="text" class="yzm_text" v-model="verifyCode" maxlength="4" placeholder="验证码">
                      <div class="yzm">
                           <span id="verify"><img alt="验证码" :src="vImg" @click="getVerifyCode('gr')">
                           <i class="ref">&nbsp;</i></span>
                      </div>
                    </li>
                    <div v-if="zcClause" class="icon2">
                      <el-checkbox v-model="tyClause">我已阅读并同意
<!--                        《<a href="javascript:void(0)"  >-->
<!--                        <el-button style="font-size: 14px" type="text" @click="open2('REG')">注册协议</el-button>-->
<!--                      </a>》及-->
                        《<a href="javascript:void(0)"  >
                        <el-button style="font-size: 14px" type="text" @click="open2('SERVICE')">用户服务协议</el-button></a>》</el-checkbox>
                    </div>
                    <div style="height:40px; font-size:16px; color:#696969; padding-top:18px; "><div v-if="showAlert">
                      <el-alert
                        :closable="false"
                        :title="alertMsg"
                        :type="alertType"
                        show-icon>
                      </el-alert>
                    </div></div>
                    <li class="userbtn">
                      <button id="btn_login" type="button" v-bind:disabled="isDisabled" @click="userLogin">{{loginText}}</button>
                    </li>
                    <li class="other" v-if="smsShow && !pwdShow && !xgShow" style="display: flex; justify-content: space-between;">
                      <a href="javascript:void(0)" @click="toSms('pwd')">密码登录</a>
                      <a href="javascript:void(0)" @click="toSms('zc')" style="margin-right: 5px;">账号注册</a>
                      <a href="javascript:void(0)" @click="goTyrz()">青海省统一认证登录</a>

                    </li>
                    <li class="other" v-if="pwdShow && !xgShow" style="display: flex; justify-content: space-between;">
                      <a href="javascript:void(0)" @click="toSms('sms')">短信登录</a>
                      <a href="javascript:void(0)" @click="toSms('wj')" style="margin-right: 5px;">忘记密码</a>
                      <a href="javascript:void(0)" @click="toSms('zc')" style="margin-right: 5px;">账号注册</a>
                      <a href="javascript:void(0)" @click="goTyrz()">青海省统一认证登录</a>
                    </li>

                    <li class="other" v-if="pwdShow && xgShow" style="display: flex; justify-content: space-between;">
                    </li>
                  </ul>
                    <div class="explain" >
                      <el-alert  :closable="false"
                                 type="warning"
                                 center
                                 show-icon>
                        <template #title>
                          <div style="font-size: 12px;text-align: left;width: 100%;">登录/注册即代表已阅读并同意用户《<a href="javascript:void(0)"  >
                            <el-button style="font-size: 8px" type="text" @click="open2('SERVICE')">用户服务协议</el-button>
                          </a>》</div>
                        </template>
                      </el-alert>
                    </div>
                </div>

         <!--     </el-tab-pane>-->
              <!--<el-tab-pane label="法人登陆" name="two">
                <div class="login-box">
                  <ul>
                    <li v-if="!frzc && frpwdShow">
                      <label><i class="icon4">&nbsp;</i></label>
                      <input  v-model="idcard_num" type="text" class="dfp_text" maxlength="18"   placeholder="请输入手机号/统一社会信用代码">
                    </li>
                    <li v-if="frzc || frloginWay=='wj'">
                      <label><i class="icon4">&nbsp;</i></label>
                      <input  v-model="fridcard_num" type="text" class="dfp_text" maxlength="18"   placeholder="请输入统一社会信用代码">
                    </li>
                    <li  v-if="frzc  || frsmsShow">
                      <label><i class="icon4">&nbsp;</i></label>
                      <input  v-model="frtel" type="text" class="dfp_text" maxlength="11"   placeholder="请输入手机号">
                    </li>
                    <li v-if="frzc || frpwdShow || frloginWay=='xg'">
                      <label><i class="icon2">&nbsp;</i></label>
                      <input type="password"  class="dfp_text" v-model="frpassword" maxlength="20" placeholder="输入密码">
                      <i class="eye-line">&nbsp;</i>
                      <i class="eye">&nbsp;</i>
                      <em></em>
                    </li>
                    <li  v-if="frzc || frloginWay=='xg'">
                      <label><i class="icon2">&nbsp;</i></label>
                      <input type="password"  class="dfp_text" v-model="frqrpassword" maxlength="20" placeholder="输入确认密码">
                      <i class="eye-line">&nbsp;</i>
                      <i class="eye">&nbsp;</i>
                      <em></em>
                    </li>
                    <li class="yzm_con" v-if="frzc || frsmsShow">
                      <label><i class="icon5">&nbsp;</i></label>
                      <input type="text" class="yzm_text" v-model="frsmsCode" maxlength="4" placeholder="输入短信校验码">
                      <div class="yzm">
                           <span id="frverifysms">  <el-link type="primary" v-bind:disabled="frsmsIsDisabled" v-on:click="countDownfr"  class="code">{{frsmsText}}</el-link>
                           <i class="ref">&nbsp;</i></span>
                      </div>
                    </li>
                    <li  class="yzm_con" v-if="frpwdShow || frloginWay=='xg'">
                      <label><i class="icon3">&nbsp;</i></label>
                      <input type="text" class="yzm_text" v-model="frverifyCode" maxlength="4" placeholder="验证码">
                      <div class="yzm">
                           <span id="frverify"><img alt="验证码" :src="frvImg" @click="getVerifyCode('fr')">
                           <i class="ref">&nbsp;</i></span>
                      </div>
                    </li>

                    <div style="height:40px; font-size:16px; color:#696969; padding-top:18px; "><div v-if="frshowAlert">
                      <el-alert
                        :closable="false"
                        :title="fralertMsg"
                        :type="fralertType"
                        show-icon>
                      </el-alert>
                    </div></div>
                    <li class="userbtn">
                      <button id="frbtn_login" type="button" v-bind:disabled="frisDisabled" @click="userLoginfr">{{loginTextfr}}</button>
                    </li>
                    <li class="other" v-if="frzc" style="display: flex; justify-content: space-between;">
                      <a href="javascript:void(0)" @click="toSmsfr('sms')">短信登录</a>
                      <a href="javascript:void(0)" @click="toSmsfr('pwd')">账号登录</a>
                      <a href="javascript:void(0)" @click="toSmsfr('wj')" style="margin-right: 5px;">忘记密码</a>
                    </li>
                    <li class="other" v-if="!frzc && frloginWay!='wj'" style="display: flex; justify-content: space-between;">
                      <a href="javascript:void(0)" @click="toSmsfr('sms')" v-if="frpwdShow">短信登录</a>
                      <a href="javascript:void(0)" @click="toSmsfr('pwd')" v-if="frsmsShow">账号登录</a>
                      <a href="javascript:void(0)" @click="toSmsfr('wj')" style="margin-right: 5px;">忘记密码</a>
                      <a href="javascript:void(0)" @click="toSmsfr('zc')" style="margin-right: 5px;">快速注册</a>

                    </li>
                    <li class="other" v-if="!frzc && frloginWay=='wj'" style="display: flex; justify-content: space-between;">
                      <a href="javascript:void(0)" @click="toSmsfr('sms')">短信登录</a>
                      <a href="javascript:void(0)" @click="toSmsfr('pwd')" >账号登录</a>
                      <a href="javascript:void(0)" @click="toSmsfr('zc')" style="margin-right: 5px;">快速注册</a>
                    </li>
                  </ul>
                  &lt;!&ndash;  <div class="explain" >
                      <el-alert  :closable="false"
                                 type="warning"
                                 center
                                 show-icon>
                        <template #title>
                          <div style="font-size: 12px;text-align: left;width: 100%;">登录/注册即代表已阅读并同意《<a href="javascript:void(0)"  >
                            <el-button type="text" @click="open2">用户服务协议及隐私政策</el-button>
                          </a>》</div>
                        </template>
                      </el-alert>
                    </div>&ndash;&gt;
                </div>


              </el-tab-pane>-->
            </el-tabs>
          </div>
        </div>
      </el-dialog>
      <el-dialog  :visible.sync="dialogQx" width="464px" :lock-scroll="false" :close-on-click-modal="false">
        <div>
          <div class="login_banner"><img src="../../static/images/login_banner.png"></div>
          <div style="width:374px;margin:0px auto 0px auto;margin-top: 20px;">
            <ul>
              <li style="width:374px; height:50px;">
                区划：
                <el-cascader v-model="selectedRegion" :props="props"  placeholder="请选择区划" style="width: 280px;"></el-cascader>
              </li>
              <!--<li style="width:374px; height:50px;">-->
              <!--单位：-->
              <!--<el-cascader :options="departOption" v-model="selecteddepartOption" clearable  placeholder="请选择办事单位" style="width: 300px;"></el-cascader>-->
              <!--</li>-->
              <div style="height:30px; font-size:16px; color:#696969;  " class="qxAlertcss">
                <div v-if="qxAlertFlag">
                  <el-alert
                    :closable="false"
                    :title="qxalertMsg"
                    :type="qxalertType"
                    show-icon>
                  </el-alert>
                </div>
              </div>
              <li >
                <button v-bind:disabled="Ok" type="button"   @click="areaSet" style="width:370px; height:60px; background:#3167ea; border:none; font-size:16px; color:#ffffff; font-family:'微软雅黑';">确&nbsp; &nbsp; 定</button>
              </li>
            </ul>
            <div style="height: 30px;" >
            </div>

          </div>
        </div>
      </el-dialog>
    </div>

  </div>

</template>

<script>
import consts from "../consts";
export default {
  name: "headers",
  inject:['reload'],
  props:{
      reloadFlag:{
        type:Boolean,
          default:false,
      },
    pageType: {
      type: String,
      default: 'home',
    },
    areaShow: {
      type: Boolean,
      default: false,
    },
    loginShow:{
      type:Boolean,
      default:false,
    },
    gotoIndex:{
      type:Boolean,
      default:false,
    },
    getPartyId: Function,
    reloadPage:Function,
  },
  components:{
  },
  data(){
    let _self=this;
    return{
      frzc:false,
      idcard_num:'',
      fridcard_num:'',
      frsmsCode:'',

      tyClause:false,
      frtel:'',
      frpassword:'',
      frqrpassword:'',
      frverifyCode:'',
      frvImg:'',
      frshowAlert:false,
      fralertMsg:'',
      fralertType:'error',
      frisDisabled:false,
      frsmsShow:true,
      frpwdShow:false,
//==============================================
      loginTabs:'first',
      verificationShow:false,
      telShow:true,
      xgShow:false,
      read:false,
      sj_str:'',
      week_str:'',
      isLogin:false,
      zcClause:false,
      dialogTableVisible:false,
      dialogQx:false,
      gridData:[],
      alertType:'error',
      qxalertType:'error',
      qxalertMsg:'',
      qxAlertFlag:false,
      smsText:'发送短信',
      frsmsText:'发送短信',
      smsIsDisabled:true,
      frsmsIsDisabled:true,
      showAlert:false,
      alertMsg:'',
      vImg:'',
      isDisabled:false,
      loginWay:'sms',
      frloginWay:'sms',
      usertel:'',
      password:'',
      qrpassword:'',
      smsCode:'',
      verifyCode:'',
      uuid:'',
      fruuid:'',
      getType:'login',
      frgetType:'',
      smsShow:true,
      pwdShow:false,
      qrpwdShow:false,
      Ok:false,
      clauseShow:false,
      clauseDefult:'REG',
      cTitle:'',
      cContent:'',
      loginText:'登  录',
      loginTextfr:'登  录',
      address:[{
        departyName:'',
        departyId:'',
      }],
      props: {
        lazy: true,
        checkStrictly:false,
        lazyLoad (node, resolve) {
          const { level } = node;
          var t=0;
          if(!node.value){
            node.value=_self.$cookies.get("areaRoot");
            t=1;
            //上级为空，默认设置大通县数据
          }
          // if(t==1){
          //   const nodes =[{label:'西宁市',value:'63010001',level:0, leaf: level >= 2}];
          //   resolve(nodes);
          // }else{
            // const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 1}];
            // resolve(nodes);
          // }

          const options={pid:node.value}
          _self.$https.post("api/pu/getAreaByParentCode.do",options,response=>{
            const nodes =[];
            // if(t==0) {
              if (response.status === 200 && response.data.code === 200) {
                const nodes = Object.values(response.data.data).map(function (e) {
                  return {label: e.name, value: e.code, level: 0, leaf: level >= 1}
                })
                resolve(nodes);
              } else {
                resolve(nodes);
              }
              // const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 1}];
              // resolve(nodes);
            // }else{
            // //   const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 2}];
            // //   resolve(nodes);
            //   const nodes =[{label:'西宁市',value:'63010001',level:0, leaf: level >= 2}];
            //   resolve(nodes);
            // }
          })
        }
      },
      selectedRegion:[],
      selecteddepartOption:[],
      departOption:[],
      areaName:'',
      userId:'',

      loginType:'system',
      tyrzUrl:'',
      threeTokenId:'',
      isLegal:'',
      companyName:'',
      userName:'',
      index:'',
    }
  },
  watch:{
      reloadFlag:function(newVal,oldVal){
          if(newVal){
              this.reload();
          }
      },
    areaShow:function(){
      if(this.areaShow){
        this.dialogQx=true;
      }
    },
    loginShow:function(newVal,oldVal){
      // console.log(this.loginShow)
      if(newVal){
        if(this.loginType=='threeLogin'){
          this.threeLogin();
        }else{
          this.dialogTableVisible=true;
        }
      }
    },
    dialogTableVisible:function(){
      if(this.dialogTableVisible){
        this.getVerifyCode();
      }
    },
    // selectedRegion(nv){
    //   this.getDepartAreas(nv[nv.length-1],0);
    // }
  },
  created(){

    this.loginType=consts.SysSet.LoginType;
    this.tyrzUrl=consts.SysSet.tyrzUrl;
    // this.$cookies.remove('areaInfo');
    // window.addEventListener('keydown', this.handleKeyDown, true)//开启监听键盘按下事件
    // var areaRoot=this.$cookies.get("areaRoot");
    // if(!areaRoot){
      this.$cookies.set("areaRoot",'630001',"20D")
    // }
    this.usertel='';
    this.password='';
    this.qrpassword='';
    this.smsCode='';
    this.verifyCode='';
    this.loginWay='sms';
    var userInfo=this.$cookies.get('userInfo')
    if(this.loginType=='threeLogin'){
      this.threeTokenId=this.$cookies.get('threeTokenId')
      this.isLegal=this.$cookies.get('isLegal')
      this.companyName=this.$cookies.get('companyName')
      if(this.threeTokenId!='' && userInfo && userInfo.userId !='' && userInfo.userId !=-1){
        this.isLogin=true;
        if(this.isLegal=='1'){
          this.userName=userInfo.userName+"("+this.companyName+")";
        }else{
          this.userName=userInfo.userName;
        }
        this.userId=userInfo.userId;
      }
    }else{
      if(userInfo && userInfo.userId !='' && userInfo.userId !=-1){
        this.isLegal=this.$cookies.get('isLegal')
        this.isLogin=true;
        if(this.isLegal && this.isLegal=='1'){
          this.userName='(法人)'+userInfo.userName;
        }else{
          this.userName=userInfo.userName;
        }

        this.userId=userInfo.userId;
      }
    }

    this.initArea();

    //个人UUID
    var uuid=this.$cookies.get("uuid2");
    if(uuid == null || uuid==''){
      uuid="vc_"+this.$util.uuid.uuid2();
    }
    this.uuid=uuid;
    this.getVerifyCode('gr');
    this.$cookies.set("uuid2",uuid,"1D");

    //法人UUID
    var fruuid=this.$cookies.get("fruuid");
    if(fruuid == null || fruuid==''){
      fruuid="vfc_"+this.$util.uuid.uuid2();
    }
    this.fruuid=fruuid;
    this.getVerifyCode('fr');
    this.$cookies.set("fruuid",fruuid,"1D");

    this.tick();
    this.countDown();
    this.countDownfr();
    if(this.loginShow){
      this.loginWay='sms';
      this.dialogTableVisible=true;
    }
    if(this.areaShow){
      this.dialogQx=true;
    }
    scrollTo(0,0);
  },
  methods:{

    closeHandle(){
      this.index=this.$route.query.index;
      if(this.gotoIndex){
        this.urlTo('publicIndexQh')
      }
      if (this.index){
        this.urlTo('publicIndexQh')
      }
      //判断是否是首页，如果是首页，就重新加载一次，避免首次用户进入，登录成功后，跳到其它页面去了
      var test = window.location.hash;
      if ('#/home'==test){
        this.urlTo('publicIndexQh')
      }
      history.go(-1);

    },
    // 键盘监听enter键登录
    handleKeyDown (e) {
      // let key = null
      // if (window.event === undefined) {
      //   key = e.keyCode
      // } else {
      //   key = window.event.keyCode
      // }
      /*     if (key === 13) {
             this.userLogin()
           }*/
    },
    areaSet(){
      if(!this.selectedRegion || this.selectedRegion.length<=0){
        this.qxalertType='error';
        this.qxalertMsg='请选择区划';
        this.qxAlertFlag=true;
      }
      var departyId=this.selectedRegion.toString();
      // var provinceId='';
      // var cityId='';
      // var areaId='';
      var userId='';
      var userInfo=this.$cookies.get('userInfo')
      if(userInfo && userInfo.userId !='' && userInfo.userId !=-1){
        userId=userInfo.userId;
      }
      // if(this.selectedRegion){
      //     if(this.selectedRegion[0]){
      //       departyId=departyId+","+this.selectedRegion[0];
      //     }
      //   if(this.selectedRegion[1]){
      //     departyId=departyId+","+selectedRegion[1];
      //   }
      //   if(this.selectedRegion[2]){
      //     areaId=this.selectedRegion[2];
      //   }
      //   if(this.selectedRegion[3]){
      //     departyId=this.selectedRegion[3];
      //   }
      // }
      const options={
        departyId:departyId,
        // provinceId:provinceId,
        // cityId:cityId,
        // areaId:areaId,
        userId:userId
      }
      var t=this;
      this.$https.post("api/pu/savePuUserAreaWeb.do",options,response=>{
        if (response.status === 200 && response.data.code===200) {
          if(response.data.data){
            t.$cookies.set("areaInfo",response.data.data,"1D")
            t.qxalertType='success';
            t.qxalertMsg='区划配置成功!';
            t.Ok=true;
            t.qxAlertFlag=true;
            t.$message({
              message: '区划配置成功！',
              type: 'success',
              duration:2500,
              onClose:function(){
                t.dialogQx=false;
                t.Ok=false;
              }
            });
            t.initAreaInfo();
          }else{
            t.qxalertType='error';
            t.qxalertMsg='受理单位配置异常，请稍后重试!';
            t.qxAlertFlag=true;
          }
        } else {
          t.qxalertType='error';
          t.qxalertMsg='受理单位配置异常，请稍后重试!';
          t.qxAlertFlag=true;
        }
      })
    },
    initArea(){
      // this.$cookies.remove('areaInfo')
      var areaInfo=this.$cookies.get('areaInfo')
      //areaInfo.departyId是一个体现省市区的数组[省ID，市ID]
      if(areaInfo && areaInfo.departyId && areaInfo.departyId.length>0){
        this.initAreaInfo();
      }else{
        //判断用户是否登录，如果登录了，查询后端配置的区划信息
        var t=this;
        if(this.isLogin && this.userId && this.userId!='' && this.userId!=-1) {
          this.$https.post("api/pu/getPuUserAreaWeb.do",{userId:this.userId},response=>{
            if (response.status === 200 && response.data.code===200 && response.data.data !=null && response.data.data.departyId && response.data.data.departyId.length>0) {
              t.$cookies.set("areaInfo",response.data.data,"1D")
              t.initAreaInfo();
            }
          })
        }else {
      /*    this.areaName = '大通县';
          this.selectedRegion=['63010001','6301210001'];

          // var obj={
          //   departyName:'大通县',
          //   departyId:['63010001','6301210001']
          // }

          this.address.departyId=this.selectedRegion;
          this.address.departyName=this.areaName;
          this.$cookies.set("areaInfo", {departyId:this.selectedRegion,departyName:this.areaName},"1D")
          this.$cookies.set("partyId",this.selectedRegion[this.selectedRegion.length-1],"1D");*/
        }
      }
    },
    initAreaInfo(){
      var areaInfo=this.$cookies.get('areaInfo')
      //areaInfo.departyId是一个体现省市区的数组[省ID，市ID]
      if(areaInfo && areaInfo.departyId && areaInfo.departyId.length>0) {
        this.areaName = areaInfo.departyName;
        this.selectedRegion=areaInfo.departyId;
        if (this.getPartyId) {
          this.getPartyId(areaInfo.departyId[areaInfo.departyId.length-1]);
          this.$cookies.set("partyId",areaInfo.departyId[areaInfo.departyId.length-1],"1D");
        }
      }else {
        // this.areaName = '西宁市';
        // this.selectedRegion=['63010001'];
       /* this.areaName = '大通县';
        this.selectedRegion=['63010001','6301210001'];
        this.address.departyId=this.selectedRegion;
        this.address.departyName=this.areaName;
        this.$cookies.set("areaInfo", {departyId:this.selectedRegion,departyName:this.areaName},"1D")
        this.$cookies.set("partyId",this.selectedRegion[this.selectedRegion.length-1],"1D");*/
      }
    },
    showDia(){
      this.dialogTableVisible=true;
    },
    // getDepartAreas(ParentId,index){
    //   const options={pid:ParentId}
    //   var t=this;
    //   this.$https.post("api/pu/getPartyByParentAreaCode.do",options,response=>{
    //     if (response.status === 200 && response.data.code===200) {
    //       t.departOption = Object.values(response.data.data).map(function(e){
    //         return {label:e.name,value:e.code,leaf:true}
    //       })
    //     } else {
    //       t.departOption =[];
    //     }
    //   })
    // },
    setQhClick(){
      this.qxalertType='error';
      this.qxalertMsg='';
      this.qxAlertFlag=false;
      this.dialogQx=true;
    },
    userLogin() {
      this.alertType='error';
      if(this.usertel==''){
        this.alertMsg='请输入手机号';
        this.showAlert=true;
        return false;
      }else{
        let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!myreg.test(this.usertel)) {
          this.alertMsg="请输入正确的手机号";
          this.showAlert=true;
          return;
        }
      }

      if(this.zcClause){
        if(this.tyClause==false){
          this.alertMsg='请阅读并同意注册协议以及服务条款';
          this.showAlert=true;
          return false;
        }
      }
      if(this.smsShow){
        if(this.smsCode==''){
          this.alertMsg='请输入短信校验码';
          this.showAlert=true;
          return false;
        }else{
          if(this.smsCode.length !=4){
            this.alertMsg='请输入正确短信校验码';
            this.showAlert=true;
            return false;
          }
        }
      }
      if(this.pwdShow){
        if(this.password==''){
          this.alertMsg='请输入登录密码';
          this.showAlert=true;
          return false;
        }else{
          var patrn=/^(\w){6,20}$/;
          if (!patrn.exec(this.password)){
            this.alertMsg='登录密码只能由6-20位字母、数字、下划线组成';
            this.showAlert=true;
            this.password='';
            this.qrpassword='';
            return false
          }
        }
        if(this.qrpwdShow && this.password !=this.qrpassword){
          this.alertMsg='两次密码输入不一致，请重新输入确认密码';
          this.showAlert=true;
          this.qrpassword='';
          return false
        }
      }
      if (this.verificationShow){
        if(this.verifyCode==''){
          this.alertMsg='请输入验证码';
          this.showAlert=true;
          return false;
        }
        if(this.verifyCode.length!=4){
          this.alertMsg='请输入正确的验证码';
          this.showAlert=true;
          return false;
        }
      }

      if(this.uuid == null || this.uuid==''){
        this.uuid="vc_"+this.$util.uuid.uuid2();
      }

      this.alertMsg='';
      this.showAlert=false;
      this.isDisabled=true;
      const options={
        loginWay:this.loginWay,
        usertel:this.usertel,
        verifyCode:this.verifyCode,
        smsCode:this.smsCode,
        password:this.password,
        uuid:this.uuid,
        qrpassword:this.qrpassword,
        verificationShow:this.verificationShow,
        getType:this.getType
      }
      //从服务器获取code请求路径snsapi_base静默，snsapi_userinfo用户授权
      var tt=this;
      this.$https.post("api/pu/userLoginWeb.do",options,response=>{
        if (response.status === 200 && response.data.code===200) {
          this.browseLog("user","login")
          this.isDisabled=true;
          //弹框成功提示，并返回登录页面
          tt.alertType='success';
          tt.alertMsg='登录成功';
          tt.showAlert=true;
          tt.$cookies.set("userId",response.data.data.userId,"1D")
          tt.$cookies.set("token",response.data.data.token,"1D")
          tt.$cookies.set("userInfo",response.data.data,"1D")
          tt.$cookies.set("isLegal",response.data.data.isLegal,"1D")
          tt.isLogin=true;
          tt.userName=response.data.data.userName;
          tt.$message({
            message: '登录成功！',
            type: 'success',
            duration:2500,
            onClose:function(){
              tt.dialogTableVisible=false;
              var _departyId=tt.selectedRegion.toString();
              console.log("user_iu_login_:",response.data.data.userId)
              tt.$https.post("api/pu/getPuUserAreaWeb.do",{userId:response.data.data.userId,departyId:_departyId},response=>{
                if (response.status === 200 && response.data.code===200 && response.data.data !=null) {
                  tt.$cookies.set("areaInfo",response.data.data,"1D")
                  // tt.initAreaInfo();
                }
                tt.reload();
              })
              // if(tt.reloadPage){
              // }
            }
          });

        } else {
          this.isDisabled=false;
          tt.verifyCode='';
          tt.getVerifyCode();
          if(response.data.code===202){
            //短信校验码错误
            tt.alertMsg='验证码错误，请重新输入';
            tt.showAlert=true;
            return;
          } else if(response.data.code===20201){
            //短信校验码超时
            tt.alertMsg='验证码过期，请重新输入';
            tt.showAlert=true;
            return;
          }else if(response.data.code===203){
            //手机号存在
            tt.smsCode='';
            tt.alertMsg='短信校验码错误，请重新输入';
            tt.showAlert=true;
            return;
          }else if(response.data.code===20301){
            //手机号存在
            tt.smsCode='';
            tt.alertMsg='短信校验码过期，请重新获取';
            tt.showAlert=true;
            return;
          }else if(response.data.code===205){
            //手机号存在
            tt.password='';
            tt.alertMsg='登录密码错误，请重新输入';
            tt.showAlert=true;
            return;
          }else if(response.data.code===201){
            //手机号不存在
            tt.alertMsg='新用户注册，请完善注册信息';
            tt.showAlert=true;
            tt.pwdShow=true;
            tt.qrpwdShow=true;
            tt.smsShow=true;
            tt.loginWay='zc';
            tt.loginText="注   册";
            return;
          }else if(response.data.code===210){
            tt.alertMsg='校验成功，进入修改密码';
            tt.password='';
            tt.qrpassword='';
            tt.smsCode='';
            tt.xgShow=true;
            tt.toSms("xg");
          }else if(response.data.code===211){
            tt.alertMsg='校验成功，成功修改密码';
            tt.xgShow=false;
            tt.telShow=true;
            tt.password='';
            tt.qrpassword='';
            tt.smsCode='';
            // alert("修改密码成功，请重新登陆")
            tt.toSms("pwd");
          }else if(response.data.code===400){
            tt.alertMsg='修改失败，请稍后重试';
            tt.xgShow=false;
            tt.telShow=true;
            tt.password='';
            tt.qrpassword='';
            this.smsCode='';
            tt.toSms("pwd");

          }else{
            tt.alertMsg=response.data.msg;
            tt.showAlert=true;
            return;
          }
        }
      })
    },
    userLoginfr() {
      this.fralertType='error';
      if(!this.frzc && this.frpwdShow){
        if(this.idcard_num==''){
          this.fralertMsg='请输入手机号/统一社会信用代码';
          this.frshowAlert=true;
          return false;
        }else{
          if(this.idcard_num.length !=11 && this.idcard_num.length !=18){
            this.fralertMsg='请输入正确的手机号/统一社会信用代码';
            this.frshowAlert=true;
            return false;
          }else{
            if(this.idcard_num.length ==11){
              let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
              if (!myreg.test(this.idcard_num)) {
                this.fralertMsg="请输入正确的手机号/统一社会信用代码";
                this.frshowAlert=true;
                return;
              }
            }
          }
        }
      }
      if(this.frzc){
        if(this.fridcard_num==''){
          this.fralertMsg='请输入统一社会信用代码';
          this.frshowAlert=true;
          return false;
        }else{
          if(this.fridcard_num.length !=18){
            this.fralertMsg='请输入正确的统一社会信用代码';
            this.frshowAlert=true;
            return false;
          }
        }
      }

     if(this.frzc  || this.frsmsShow){
       if(this.frtel==''){
         this.fralertMsg='请输入手机号';
         this.frshowAlert=true;
         return false;
       }else{
         let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
         if (!myreg.test(this.frtel)) {
           this.fralertMsg="请输入正确的手机号";
           this.frshowAlert=true;
           return;
         }
       }
     }
      if(this.frzc  || this.frpwdShow ||  this.frloginWay=='xg'){
        if(this.frpassword==''){
          this.fralertMsg='请输入登录密码';
          this.frshowAlert=true;
          return false;
        }else{
          var patrn=/^(\w){6,20}$/;
          if (!patrn.exec(this.frpassword)){
            this.fralertMsg='登录密码只能由6-20位字母、数字、下划线组成';
            this.frshowAlert=true;
            this.frpassword='';
            this.frqrpassword='';
            return false
          }
        }
      }
      if(this.frzc ||  this.frloginWay=='xg'){
        if(this.frqrpassword=='' || this.frpassword !=this.frqrpassword){
          this.fralertMsg='两次密码输入不一致，请重新输入确认密码';
          this.frshowAlert=true;
          this.frqrpassword='';
          return false
        }
      }
      if(this.frzc || this.frsmsShow){
        if(this.frsmsCode==''){
          this.fralertMsg='请输入短信校验码';
          this.frshowAlert=true;
          return false;
        }else{
          if(this.frsmsCode.length !=4){
            this.fralertMsg='请输入正确短信校验码';
            this.frshowAlert=true;
            return false;
          }
        }
      }
      if(this.frpwdShow ||  this.frloginWay=='xg'){
        if(this.frverifyCode==''){
          this.fralertMsg='请输入验证码';
          this.frshowAlert=true;
          return false;
        }
        if(this.frverifyCode.length!=4){
          this.fralertMsg='请输入正确的验证码';
          this.frshowAlert=true;
          return false;
        }
      }

      if(this.fruuid == null || this.fruuid==''){
        this.fruuid="vfc_"+this.$util.uuid.uuid2();
      }

      this.alertMsg='';
      this.showAlert=false;
      this.frisDisabled=true;
      const options={
        loginType:'fr',
        loginWay:this.frloginWay,
        idcard_num:this.idcard_num,
        fridcard_num:this.fridcard_num,
        frsmsCode:this.frsmsCode,
        frtel:this.frtel,
        frpassword:this.frpassword,
        frverifyCode:this.frverifyCode,
        fruuid:this.fruuid,
      }
      //从服务器获取code请求路径snsapi_base静默，snsapi_userinfo用户授权
      var tt=this;
      this.$https.post("api/pu/userLoginWeb.do",options,response=>{
        if (response.status === 200 && response.data.code===200) {
          this.frisDisabled=true;
          //弹框成功提示，并返回登录页面
          tt.fralertType='success';
          tt.fralertMsg='登录成功';
          tt.frshowAlert=true;
          tt.$cookies.set("userId",response.data.data.userId,"1D")
          tt.$cookies.set("isLegal",response.data.data.isLegal,"1D")
          tt.$cookies.set("token",response.data.data.token,"1D")
          tt.$cookies.set("userInfo",response.data.data,"1D")
          tt.isLogin=true;
          tt.userName='(法人)'+response.data.data.userName;
          tt.$message({
            message: '登录成功！',
            type: 'success',
            duration:2500,
            onClose:function(){
              tt.dialogTableVisible=false;
              tt.$https.post("api/pu/getPuUserAreaWeb.do",{userId:response.data.data.userId},response=>{
                if (response.status === 200 && response.data.code===200 && response.data.data !=null) {
                  tt.$cookies.set("areaInfo",response.data.data,"1D")
                  // tt.initAreaInfo();
                }
                tt.reload();
              })
              // if(tt.reloadPage){
              // }
            }
          });

        } else {
          this.frisDisabled=false;
          tt.frverifyCode='';
          tt.getVerifyCode("fr");
          if(response.data.code===202){
            //短信校验码错误
            tt.fralertMsg='验证码错误或过期，请重新输入';
            tt.frshowAlert=true;
            return;
          } else if(response.data.code===20201){
            //短信校验码超时
            tt.fralertMsg='验证码错误或过期，请重新输入';
            tt.frshowAlert=true;
            return;
          }else if(response.data.code===203){
            //手机号存在
            tt.frsmsCode='';
            tt.fralertMsg='短信校验码错误或过期，请重新输入';
            tt.frshowAlert=true;
            return;
          }else if(response.data.code===20301){
            //手机号存在
            tt.frsmsCode='';
            tt.fralertMsg='短信校验码错误或过期，请重新输入';
            tt.frshowAlert=true;
            return;
          }else if(response.data.code===20205){
            //手机号存在
            // tt.frtel='';
            tt.fralertMsg='手机号已经存在,请选择其他手机号码';
            tt.frshowAlert=true;
            return;
          }else if(response.data.code===20206){
            //手机号存在
            // tt.fridcard_num='';
            tt.fralertMsg='统一社会信用代码已经存在';
            tt.frshowAlert=true;
            return;
          }else if(response.data.code===20207){
            //手机号存在
            // tt.fridcard_num='';
            tt.fralertMsg='账号不存在，请重新输入';
            tt.frshowAlert=true;
            return;
          }else if(response.data.code===205){
            //手机号存在
            tt.frpassword='';
            tt.fralertMsg='登录密码错误，请重新输入';
            tt.frshowAlert=true;
            return;
          }else if(response.data.code===210){
            tt.fralertMsg='校验成功，请输入新密码';
            tt.frsmsCode='';
            tt.toSmsfr("xg");
          }else if(response.data.code===211){
            tt.fralertMsg='修改密码成功，请重新登陆';
            tt.frxgShow=false;
            tt.frtelShow=true;
            tt.frpassword='';
            tt.frqrpassword='';
            tt.fridcard_num='';
            tt.frtel='';
            tt.frsmsCode='';
            alert("修改密码成功，请重新登陆")
            tt.toSmsfr("pwd");
          }else if(response.data.code===400){
            tt.fralertMsg='修改失败，请稍后重试';
            tt.frtelShow=true;
            tt.frpassword='';
            tt.frqrpassword='';
            tt.fridcard_num='';
            tt.frtel='';
            tt.frsmsCode='';
            tt.toSmsfr("pwd");
          }else{
            tt.fralertMsg=response.data.msg;
            tt.frshowAlert=true;
            return;
          }
        }
      })
    },
    getVerifyCode(t){
      if(t=='fr'){
        this.frvImg=process.env.API_HOST+'/api/verifyCode_ajax.do?t=' +Math.random()+"&uuid="+this.fruuid;
      }else{
        this.vImg=process.env.API_HOST+'/api/verifyCode_ajax.do?t=' +Math.random()+"&uuid="+this.uuid;
      }


    },
    browseLog(one,two){
      const options={
        oneCode:one,
        twoCode:two,
      }
      this.$https.post("api/browse/saveBrowseLog.do",options,response=>{
      })
    },
    getSmsCode() {
      this.alertType='error';
      this.smsIsDisabled=true;
      if(this.usertel==''){
        this.alertMsg="请输入手机号";
        this.showAlert=true;
        this.smsIsDisabled=false;
        return false;
      }
      //校验手机号码格式
      let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!myreg.test(this.usertel)) {
        this.alertMsg="请输入正确的手机号";
        this.showAlert=true;
        this.smsIsDisabled=false;
        return;
      }
      this.showAlert=true;
      this.alertMsg="短信校验码获取中.....";
      this.$https.post("api/pu/getTelCode.do",{tel:this.usertel,getType:this.getType},response=>{
        if (response.status === 200 && response.data.code===200) {
          this.alertType='success';
          this.alertMsg="短信校验码发送成功";
          //倒计时
          this.countDown(120);
        } else {
          this.smsIsDisabled=false;
          this.alertMsg=response.data.msg;
        }
      })
    },
    getSmsCodefr() {
      this.fralertType='error';
      this.frsmsIsDisabled=true;
      if(this.frtel==''){
        this.fralertMsg="请输入手机号";
        this.frshowAlert=true;
        this.frsmsIsDisabled=false;
        return false;
      }
      //校验手机号码格式
      let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!myreg.test(this.frtel)) {
        this.fralertMsg="请输入正确的手机号";
        this.frshowAlert=true;
        this.frsmsIsDisabled=false;
        return;
      }
      this.frshowAlert=true;
      this.fralertMsg="短信校验码获取中.....";
      this.$https.post("api/pu/getTelCode.do",{tel:this.frtel,getType:this.frgetType},response=>{
        if (response.status === 200 && response.data.code===200) {
          this.fralertType='success';
          this.fralertType="短信校验码发送成功";
          //倒计时
          this.countDown(120);
        } else {
          this.frsmsIsDisabled=false;
          this.fralertMsg=response.data.msg;
        }
      })
    },
    loginClick(dd){
      this.dialogTableVisible = true;
      this.zcClause = false;
      this.getType='zc';
      this.toSms(dd);
    },
    clauseClose(){
      this.clauseShow=false;
    },
    open2(type){
      this.$https.get("api/pu/clause/getClauseContentByType.do",{cType:type},response=>{
        if (response.status === 200 && response.data.code===200) {
          this.cTitle=response.data.data.cTitle;
          this.cContent=response.data.data.cContent;
        } else {

        }
      })
      this.clauseShow=true;
    },
    goTyrz(){
      window.location.href= this.tyrzUrl;
    },
    toSms(aa){
      this.loginWay=aa;
      if(aa=='zc'){
        this.tyClause=false;
        this.verificationShow=false;
        this.showAlert=false;
        this.telShow=true;
        this.smsShow=true;
        this.pwdShow=true;
        this.qrpwdShow=true;
        this.password='';
        this.qrpassword='';
        this.smsCode='';
        this.getType='zc';
        this.xgShow=false;
        this.loginText="注   册";
        this.zcClause=true;
      }
      else if(aa=='pwd'){
        this.zcClause=false;
        this.verificationShow=true;
        this.password='';
        this.qrpassword='';
        this.smsCode='';
        this.getType='login';
        this.showAlert=false;
        this.telShow=true;
        this.xgShow=false;
        this.smsShow=false;
        this.pwdShow=true;
        this.qrpwdShow=false;
        this.loginText="登   录";
      }else if(aa=='xg'){
        this.verificationShow=true;
        this.password='';
        this.qrpassword='';
        this.smsCode='';
        this.zcClause=false;
        this.showAlert=false;
        this.telShow=false;
        this.smsShow=false;
        this.pwdShow=true;
        this.qrpwdShow=true;
        this.loginText="确认修改";
      }else if(aa=='wj'){
        this.verificationShow=false;
        this.showAlert=false;
        this.smsShow=true;
        this.pwdShow=false;
        this.qrpwdShow=false;
        this.password='';
        this.qrpassword='';
        this.smsCode='';
        this.getType='login';
        this.zcClause=false;
        this.loginText="下一步";
      }else{
        this.password='';
        this.qrpassword='';
        this.smsCode='';
        this.getType='login';
        this.verificationShow=false;
        this.showAlert=false;
        this.telShow=true;
        this.smsShow=true;
        this.pwdShow=false;
        this.qrpwdShow=false;
        this.xgShow=false;
        this.zcClause=false;
        this.loginText="登   录";
      }
    },
    toSmsfr(aa){
      this.frloginWay=aa;
      this.frpassword='';
      this.frqrpassword='';
      this.frshowAlert=false;
      if(aa=='zc'){
        this.frzc=true;

        this.frsmsShow=true;
        this.frpwdShow=true;
        this.frgetType='zc';
        this.loginTextfr="注   册";
      }
      else if(aa=='pwd'){
        this.frzc=false;
        this.frsmsShow=false;
        this.frpwdShow=true;
        this.frgetType='';
        this.loginTextfr="登   录";
      }else if(aa=='wj'){
        this.frzc=false;
        this.frpwdShow=false;
        this.frsmsShow=true;
        // this.frqrpwdShow=false;
        this.frsmsCode='';
        this.frgetType='';
        this.loginTextfr="下一步";
      }else if(aa=='xg'){
        this.frzc=false;
        this.frpassword='';
        this.frqrpassword='';
        this.loginText="确认修改";
      }else{
        this.frzc=false;
        this.frsmsShow=true;
        this.frpwdShow=false;
        this.frsmsCode='';
        this.getType='';
        this.loginTextfr="登   录";
      }
    },
    countDown(times){
      var time;
      if(times){
        time=times;
      }else{
        time=this.$cookies.get("time1")
        if(!time){
          this.smsIsDisabled=false;
          return;
        }
      }
      time=time-1;
      this.$cookies.set("time1",time,time+"s")
      if(time<=0){
        this.smsIsDisabled=false;
        this.smsText="发送短信";
        this.$cookies.remove("time1")
        return
      }else{
        this.smsText=time+"秒"
        var t=this;
        setTimeout(function() {
          t.countDown(time);
        },1000)
      }
    },
    countDownfr(times){
      var time;
      if(times){
        time=times;
      }else{
        time=this.$cookies.get("timefr")
        if(!time){
          this.frsmsIsDisabled=false;
          return;
        }
      }
      time=time-1;
      this.$cookies.set("timefr",time,time+"s")
      if(time<=0){
        this.frsmsIsDisabled=false;
        this.frsmsText="发送短信";
        this.$cookies.remove("timefr")
        return
      }else{
        this.frsmsText=time+"秒"
        var t=this;
        setTimeout(function() {
          t.countDownfr(time);
        },1000)
      }
    },
    urlTo(url,params){
      this.$router.push({path:url,query:params||{}});
    },
    getClass(t){
      if(t==this.pageType){
        return "on";
      }else{
        return "";
      }
    },
    showLocale(objD) {
      var str, colorhead, colorfoot;
      var yy = objD.getYear();
      if (yy < 1900) yy = yy + 1900;
      var MM = objD.getMonth() + 1;
      if (MM < 10) MM = '0' + MM;
      var dd = objD.getDate();
      if (dd < 10) dd = '0' + dd;
      // var hh = objD.getHours();
      // if (hh < 10) hh = '0' + hh;
      // var mm = objD.getMinutes();
      // if (mm < 10) mm = '0' + mm;
      // var ss = objD.getSeconds();
      // if (ss < 10) ss = '0' + ss;
      var ww = objD.getDay();
      if (ww == 0) colorhead = "";
      if (ww > 0 && ww < 6) colorhead = "";
      if (ww == 6) colorhead = "";
      if (ww == 0) ww = "星期日";
      if (ww == 1) ww = "星期一";
      if (ww == 2) ww = "星期二";
      if (ww == 3) ww = "星期三";
      if (ww == 4) ww = "星期四";
      if (ww == 5) ww = "星期五";
      if (ww == 6) ww = "星期六";
      colorfoot = ""
      this.sj_str = colorhead + yy + "年" + MM + "月" + dd + "日";// + hh + ":" + mm + ":" + ss + " " ;
      this.week_str= ww + colorfoot
    },
    tick() {
      var today;
      today = new Date();
      this.showLocale(today);
      // window.setTimeout(this.tick(), 1000);
    },
    loginOut(){
      this.$cookies.remove('userInfo');
      this.$cookies.remove('userId');

      let threeTokenId=this.$cookies.get('threeTokenId');
      if(threeTokenId && threeTokenId !==''){
          this.$cookies.remove('threeTokenId');
          let returnUrl=consts.SysSet.tyrzLogoutReturnUrl;
          this.loginOutThree(threeTokenId,returnUrl);
      }else{
          this.reload();
          this.urlTo('home')
      }

      //跳转到首页，不过跳转后不能自动弹出登陆框了

      /*this.toSms("sms");*/
    },
    goOut() {
      this.$confirm('确定要退出登录吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll:false,
      }).then(() => {

        this.loginOut();
      }).catch(() => {

      });
    },
    loginOutThree(threeTokenId,returnUrl){
      var tt=this;
      //从后端获取第三方登录请求地址
      this.$https.get("api/pu/qhmzTyrzUserOutLogin.do",{tokenID:threeTokenId,redirectUrl:returnUrl},response=>{
        if (response.status === 200 && response.data.code===200) {
          window.location.href=response.data.data;
        } else {
          tt.$alert("统一认证退出登录失败，请手动清理浏览器缓存", "提示", {
            confirmButtonText: '确定'});
        }
          tt.reload();
          tt.urlTo('home')
      })
    },
    threeGoOut(){
      var t=this;
      this.$confirm('确定要退出登录吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll:false,
      }).then(() => {
        t.$cookies.remove('userInfo');
        t.$cookies.remove('userId');
        t.$cookies.remove('threeTokenId');
        //调用第三方退出登录
        t.loginOutThree();
      }).catch(() => {

      });
    },
    threeLogin(){
      var tt=this;
      //从后端获取第三方登录请求地址
      this.$https.get("api/pu/threeLoginUrl.do",{},response=>{
        if (response.status === 200 && response.data.code===200) {
          window.open(response.data.data);
        } else {
          tt.$alert(response.data.msg, "提示", {
            confirmButtonText: '确定'});
        }
      })
    }
  }
}
</script>

<style>
  .dialog_css .el-dialog__body {
    padding: 0;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
  }
  .dialog_css .el-dialog__header {
    padding: 0px;
  }
  .dialog_css .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 20px;
    font-weight: 900;
  }
  .explain .el-alert {
    width: 100%;
    /* padding: 8px 16px; */
    padding: 0;
    padding-bottom: 8px;
    margin: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 4px;
    position: relative;
    background-color: #FFF;
    overflow: hidden;
    opacity: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-transition: opacity .2s;
    transition: opacity .2s;
  }
  .qxAlertcss .el-alert {
    width: 100%;
    /* padding: 8px 16px; */
    padding: 0;
    padding-bottom: 8px;
    margin: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 4px;
    position: relative;
    background-color: #FFF;
    overflow: hidden;
    opacity: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-transition: opacity .2s;
    transition: opacity .2s;
  }

</style>



// WEBPACK FOOTER //
// src/components/Headers.vue